<wtf-dialogcontent [size]="'md'" [dialogTitle]="dialogTitle" (closeModal)="dialogRef.close()" [action]="action">
    <!-- Content -->

    <form name="protocolForm" [formGroup]="protocolForm" class="tax-type-form w-100-p p-20" fxLayout="column" fxFlex>
        <div fxLayout="row" fxLayoutAlign="end center">
            <mat-label>{{ "*Campos Obligatorios" | translate }}</mat-label>
        </div>
        <div class="labels" fxLayout="row" fxLayoutWrap fxShow.gt-sm *ngIf="action === recordAction.View">
            <div class="label" fxLayout="row" fxLayoutAlign="start center">
                <div class="label-color" [ngStyle]="{
                        'background-color': protocolModel.active
                            ? 'green'
                            : 'red'
                    }"></div>
                <div class="label-title">Activo</div>
            </div>
        </div>
        <mat-label>{{ "Nombre del Protocolo" | translate }}*</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="name" formControlName="name" mat-maxlength="50" placeholder=""
                [readonly]="action === recordAction.View" required />
        </mat-form-field>

        <button *ngIf="action !== recordAction.Update" mat-raised-button (click)="performAction()" class="save-button"
            [disabled]="protocolForm.invalid" aria-label="GUARDAR">
            <span class="material-icons-outlined mr-16"> save </span>
            <span>{{ "Guardar" | translate }}</span>
        </button>

        <button *ngIf="action === recordAction.Update" mat-raised-button (click)="performAction()" class="save-button"
            [disabled]="protocolForm.invalid" aria-label="GUARDAR">
            <span class="material-icons-outlined mr-16"> save </span>
            <span>{{ "Guardar" | translate }}</span>
        </button>
    </form>
    <!-- Content -->

    <!-- Buttons -->
</wtf-dialogcontent>